module.exports = {
  CUSTOM_CATEGORY_ADD: 'CUSTOM_CATEGORY_ADD',
  CUSTOM_CATEGORY_UPDATE: 'CUSTOM_CATEGORY_UPDATE',
  CUSTOM_CATEGORY_DELETE: 'CUSTOM_CATEGORY_DELETE',
  CUSTOM_ATTRIBUTES_ADD: 'CUSTOM_ATTRIBUTES_ADD',
  CUSTOM_ATTRIBUTES_EDIT: 'CUSTOM_ATTRIBUTES_EDIT',
  CUSTOM_ATTRIBUTES_DELETE: 'CUSTOM_ATTRIBUTES_DELETE',
  SET_INITIAL_DATA: 'SET_INITIAL_DATA',


  CUSTOM_CATEGORY_EDIT: 'CUSTOM_CATEGORY_EDIT',
  ORG_ENG_UPDATE: 'ORG_ENG_UPDATE',

  OBJECT_TYPE_USER: 1,
  OBJECT_TYPE_WS: 2,
};
